/*
 * Patient Search Aggregates Actions
 */

export const FETCH_SEARCH_AGGREGATES_REQUEST = 'FETCH_SEARCH_AGGREGATES_REQUEST'
export const FETCH_SEARCH_AGGREGATES_SUCCESS = 'FETCH_SEARCH_AGGREGATES_SUCCESS'
export const FETCH_SEARCH_AGGREGATES_FAILURE = 'FETCH_SEARCH_AGGREGATES_FAILURE'
export const CLEAR_AGGREGATES = 'CLEAR_AGGREGATES'
